import React, { Component } from 'react';

class Label extends Component {
    render() {
        return (
            <div {...this.props} style={{ minWidth: '30px', minHeight: '30px' }}>{this.props.title || "label"}</div>
        );
    }
}

export default Label;
